import React from 'react';
import { Grid } from '@chakra-ui/react';
import { ReportedFinding } from '@acp/shared';

import { ReportedFindingsRow } from '../../../reported-findings/components/cards/reported-findings-row';
import { ReportedFindingTag } from '../../../reported-findings/components/wizard/reported-finding-tag-collection';

const gap = 4;

function GridWrapper({ children }: { children: React.ReactNode }) {
    return (
        <Grid
            gridTemplateRows="auto"
            gridTemplateAreas={[
                `
            "address address address"
            "service service service"
            "reported-findings reported-findings reported-findings"
            "status status status"
            "actions actions actions"
        `,
                null,
                null,
                null,
                '"address service reported-findings status actions"',
            ]}
            gridTemplateColumns={[
                '1fr 1fr',
                'min-content 1fr 1fr',
                null,
                '1fr 1fr 1fr 1fr',
                '21% 12% 30% 14% 1fr',
            ]}
            gap={gap}
            alignItems={{ base: 'center', xl: 'start' }}
            justifyItems="start"
            h="auto"
        >
            {children}
        </Grid>
    );
}

function UrgentReportedFindingsRow({
    reportedFinding,
}: {
    reportedFinding: ReportedFinding;
}) {
    return (
        <ReportedFindingsRow
            reportedFinding={reportedFinding}
            gridWrapper={GridWrapper}
            isOverviewMode
        >
            <ReportedFindingTag
                reportedFinding={reportedFinding.reportedFindings[0]}
                path={`/property/${reportedFinding.property.compliancePropertyId}/reported-findings`}
            />
        </ReportedFindingsRow>
    );
}

export { UrgentReportedFindingsRow };
